/**
 * Maps X11 numeric-keypad (KP) keysyms to their ASCII/standard equivalents so
 * numpad keystrokes reach the remote session as the same characters produced
 * by the top-row keys. Pure and idempotent: keysyms outside the exact KP range
 * are returned unchanged (NumLock-OFF navigation keysyms, KP_Equal, ASCII).
 *
 * @param keysym - the X11 keysym to normalize
 * @returns the normalized keysym, or the input unchanged when not mapped
 */
export const normalizeKeysym = (keysym: number): number => {
  if (keysym >= 0xffb0 && keysym <= 0xffb9) {
    return keysym - 0xffb0 + 0x30;
  }

  switch (keysym) {
    case 0xff8d: // KP_Enter
      return 0xff0d; // Return
    case 0xffab: // KP_Add
      return 0x2b; // '+'
    case 0xffad: // KP_Subtract
      return 0x2d; // '-'
    case 0xffaa: // KP_Multiply
      return 0x2a; // '*'
    case 0xffaf: // KP_Divide
      return 0x2f; // '/'
    case 0xffae: // KP_Decimal
      return 0x2e; // '.'
    default:
      return keysym;
  }
};